import { createModalStore } from '@/shared/lib/modal';

import { LimitedFeature, PlanCategoriesKeys } from '../lib/types';

type UseUpgradePlanModalProps = {
  fromTrialPreview?: boolean;
  limitedFeature?: LimitedFeature;
  plan?: PlanCategoriesKeys;
};

const initialState: UseUpgradePlanModalProps = {
  fromTrialPreview: false,
  limitedFeature: undefined,
};

export const useUpgradePlanModalStore = createModalStore<UseUpgradePlanModalProps>(initialState, false);
